import React, { useEffect, useState } from 'react';
import { getAITranslationTrending } from '@/libs/api';
import TrendingList, { TrendingItem } from './TrendingList';

const AiHistory: React.FC = () => {
  const [data, setData] = useState<TrendingItem[]>([]);
  const [loading, setLoading] = useState(true);

  const fetchData = async () => {
    setLoading(true);
    try {
      const result = await getAITranslationTrending('all', 20);
      if (result && result.result && Array.isArray(result.result.items)) {
        setData(result.result.items);
      }
    } catch (error) {
      console.error('获取AI翻译历史失败:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <TrendingList
      title="AI翻译热词"
      data={data}
      loading={loading}
      onRefresh={fetchData}
    />
  );
};

export default AiHistory;
